module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAYAAABNChwpAAAAAXNSR0IArs4c6QAAATVJREFUWEft1j8vREEUBfDfKtDwITR6UVMpJKj865Do0O6X0KIREhokFP4kEolEdBpR6nwJCYkImYRksnkvs/um2C3eKyf3zj333HfunIYuf40u11cDKGJgCJO4x0c0omFMY6Di2MJdt3iP84sAXGIOB1iPgu8wVbH4f9oNZlMADrGGbTSj4P0WQFWw7GArBSCwMorXggojGSP4xFvrnbUKagZ6koF+jOMJ39FfG84nMFhFf39L7RFfKRmeYRF72IiCr1qXSAUg51hoF8AuNqPgUyxVKBqnHGMlBaBsBH0Yy1xEz/hJAchssrP0nlRBZy1kRtcMFDFQ9hyH8xwVBEf00o4KygzJCZYzR36E1ZQMyyzZNWYyAVxgPgWgzJQGMxrMalVTGhzRQztvQWaTnaXXMuw6A7+JeTMfe2K4nQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_item.png
// module id = jB92
// module chunks = 1